<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:model-value'])
</script>

<template>
  <v-tooltip>
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        class="position-absolute expand-button"
        @click="emit('update:model-value', !modelValue)"
        size="24"
        variant="flat"
        color="white"
        icon
      >
        <v-icon size="18" color="grey-darken-2">
          {{ modelValue ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
        </v-icon>
      </v-btn>
    </template>
    {{ modelValue ? 'Collapse' : 'Expand' }}
  </v-tooltip>
</template>

<style scoped>
.expand-button {
  top: 12px;
  left: -12px;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}
</style>
